var View = require('views/base/view');
var GroupLinkView = require('./group-link-view');
var MenuService = require('services/menu-service');

var GroupItemView = View.extend({
  noWrap: true,
  regions: {
    'group-link': '.group-link'
  },
  template: require('./templates/group-item'),
  initialize: function(options) {
    this.model.set('linkPath', 'menu/' + options.groupPage + '?group=' + this.model.get('id'));
    View.prototype.initialize.apply(this, arguments);
    var self = this;
    this.on('addedToParent', function() {
      self.container = self.el;
      var linkView = new GroupLinkView({
        model: self.model,
        region: 'group-link',
        groupTemplate: options.groupTemplate
      });
      self.subview('groupLink', linkView);
    });
  },
  getTemplateData: function() {
    var obj = this.model.serialize();
    //TODO: this is only setting a group in-progress if a module has been completed
    // would like this to check the module's status, but there's no in-progress status for a module yet
    var completedModules = this.model.modules.filter({ completed: true });
    var completedPercentage = completedModules.length / this.model.modules.length;
    switch(completedPercentage) {
      case 1:
        obj.status = 'completed';
        break;
      case 0:
        obj.status = 'not-started';
        break;
      default:
        obj.status = 'in-progress';
        break;
    }
    if(MenuService.currentGroup === this.model) {
      obj.status += ' active';
    }
    obj.lockState = this.model.get('locked') ? 'locked' : 'unlocked';
    obj.unlocked = !obj.locked;

    return obj;
  }
});

module.exports = GroupItemView;
